import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinnovacrystacabs() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Innova Crysta Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Innova Crysta Cab',
    headingDescription: 'Sai Trupti Cabs provides premium Pune to Mumbai Innova Crysta cab services, offering a perfect blend of luxury, comfort, and safety for every traveler. Our Toyota Innova Crysta fleet features plush reclining seats, spacious legroom, powerful air-conditioning, and clean interiors to make long-distance travel truly relaxing. Whether you’re heading to Mumbai city, Navi Mumbai, or Mumbai Airport, our professional and background-verified chauffeurs ensure punctual pickups, courteous service, and smooth driving throughout the journey. Ideal for families, corporate trips, and group travel, Sai Trupti Cabs guarantees transparent pricing, flexible one-way or round-trip options, and 24×7 customer support. Enjoy a first-class travel experience with Sai Trupti Cabs — your trusted choice for Pune to Mumbai Innova Crysta cab services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Innova Crysta Cab",
    "description": "Pune to Mumbai Innova Crysta Cab offers premium, spacious, and comfortable travel with the versatile Toyota Innova Crysta. Ideal for families, groups, and business travelers, the service provides air-conditioned comfort, professional drivers, punctual pickups, ample luggage space, online booking, transparent fares, 24/7 customer support, and smooth, reliable intercity travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Pune to Mumbai Innova Cab provides hassle-free intercity travel with well-maintained Toyota Innova vehicles. Passengers enjoy spacious seating, air-conditioned interiors, professional drivers, online booking, transparent pricing, real-time ride tracking, 24/7 support, and flexible options for one-way trips, round trips, or airport transfers."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Taxi",
    "description": "Pune to Mumbai Innova Crysta Taxi ensures safe, comfortable, and reliable travel with experienced chauffeurs and premium Innova Crysta vehicles. Services include door-to-door pickups, air-conditioned comfort, spacious seating, transparent fares, online booking, and 24/7 customer support for stress-free Pune-Mumbai travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Hire",
    "description": "Pune to Mumbai Innova Crysta Hire offers flexible rental options for self-drive or chauffeur-driven trips. Passengers benefit from air-conditioned comfort, spacious interiors, professional driving, transparent pricing, online booking, 24/7 support, and flexible travel durations, ensuring smooth intercity travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta One Way Cab",
    "description": "Pune to Mumbai Innova Crysta One Way Cab specializes in convenient and economical one-way trips. The service includes spacious seating, air-conditioned comfort, professional drivers, transparent fares, online booking, real-time ride tracking, and hassle-free travel for families, groups, and business travelers."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Drop",
    "description": "Pune to Mumbai Innova Crysta Drop offers reliable one-way drop services with punctual pickups, comfortable and spacious vehicles, professional chauffeurs, transparent fares, online booking, and 24/7 support. Ideal for airport transfers, outstation trips, or personal travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Luxury Cab",
    "description": "Pune to Mumbai Innova Crysta Luxury Cab provides a premium travel experience with plush interiors, air-conditioned comfort, professional drivers, transparent pricing, online booking, real-time ride tracking, 24/7 support, and smooth, safe, and elegant travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Outstation Cab",
    "description": "Pune to Mumbai Innova Crysta Outstation Cab ensures long-distance travel comfort and reliability. The service features air-conditioned interiors, professional drivers, spacious seating, transparent fares, online booking, real-time ride updates, and 24/7 support for outstation or intercity trips."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Airport Taxi",
    "description": "Pune to Mumbai Innova Crysta Airport Taxi provides dedicated airport transfer services with timely pickups, air-conditioned comfort, professional chauffeurs, transparent pricing, online booking, real-time ride tracking, and 24/7 support, ensuring stress-free travel to and from Mumbai airports."
  },
  {
    "name": "Affordable Pune to Mumbai Innova Cab",
    "description": "Affordable Pune to Mumbai Innova Cab offers budget-friendly travel without compromising on comfort. Passengers can enjoy spacious seating, air-conditioned interiors, professional drivers, transparent fares, online booking, 24/7 support, and flexible options for families, groups, or business travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Online Booking",
    "description": "Pune to Mumbai Innova Crysta Online Booking allows passengers to reserve Innova Crysta cabs conveniently via an online platform. Features include instant confirmation, multiple vehicle options, transparent pricing, real-time ride tracking, 24/7 customer support, and easy management of bookings for smooth intercity travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta AC Cab",
    "description": "Pune to Mumbai Innova Crysta AC Cab provides fully air-conditioned rides with spacious seating, professional chauffeurs, punctual pickups, online booking, transparent fares, real-time tracking, and 24/7 support, ensuring comfortable and convenient travel."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Sedan Cab",
    "description": "Pune to Mumbai Innova Crysta Sedan Cab combines the comfort of Innova Crysta with sedan-like features for passengers seeking a balanced luxury and spacious experience. Services include air-conditioned interiors, professional drivers, transparent fares, online booking, and 24/7 support."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Car Service",
    "description": "Pune to Mumbai Innova Crysta Car Service offers professional and reliable intercity travel solutions. Features include spacious seating, air-conditioned comfort, experienced drivers, transparent fares, online booking, real-time ride tracking, and 24/7 support for business, family, or airport trips."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Travel Service",
    "description": "Pune to Mumbai Innova Crysta Travel Service provides comprehensive travel solutions, including one-way trips, round trips, airport transfers, and outstation journeys. Passengers enjoy air-conditioned comfort, spacious interiors, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 customer support."
  }
],
"tableData": [
  ["Pune to Mumbai Innova Crysta Cab", "Pune to Mumbai Innova Cab"],
  ["Pune to Mumbai Innova Crysta Taxi", "Pune to Mumbai Innova Crysta Hire"],
  ["Pune to Mumbai Innova Crysta One Way Cab", "Pune to Mumbai Innova Crysta Drop"],
  ["Pune to Mumbai Innova Crysta Luxury Cab", "Pune to Mumbai Innova Crysta Outstation Cab"],
  ["Pune to Mumbai Innova Crysta Airport Taxi", "Affordable Pune to Mumbai Innova Cab"],
  ["Pune to Mumbai Innova Crysta Online Booking", "Pune to Mumbai Innova Crysta AC Cab"],
  ["Pune to Mumbai Innova Crysta Sedan Cab", "Pune to Mumbai Innova Crysta Car Service"],
  ["Pune to Mumbai Innova Crysta Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Innova Crysta Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers premium and spacious cab services from Pune to Mumbai using the 6‑seater Toyota Innova Crysta — ideal for families, groups, or travelers with extra luggage."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "We provide clear, one‑way pricing for the Innova Crysta from Pune to Mumbai, inclusive of major costs — so you travel without worrying about hidden charges."
  },
  {
    "WhyChooseheading": "Comfort & Ample Space",
    "WhyChoosedescription": "The Innova Crysta features comfortable seating and generous luggage space, making it a great choice for the long‑drive between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our drivers are friendly, punctual and well‑acquainted with the Pune–Mumbai route — ensuring a safe and smooth journey in your Innova Crysta."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We handle pickups from anywhere in Pune and drop‑offs across Mumbai — including city spots, airports or rail‑stations — fully utilizing the comfort of the Innova Crysta."
  },
  {
    "WhyChooseheading": "Clean & Well‑Maintained Vehicles",
    "WhyChoosedescription": "Each Innova Crysta in our fleet is regularly serviced, sanitized and checked for a comfortable outstation ride from Pune to Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Booking & Support",
    "WhyChoosedescription": "Our support team is available around the clock to help you book your Pune to Mumbai Innova Crysta cab, change plans or answer queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai Innova Crysta cab effortlessly via call, WhatsApp or our website — with instant confirmation and prompt vehicle dispatch."
  }
]































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai Innova Crysta cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and comfortable Pune to Mumbai Innova Crysta cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pune to Mumbai Innova Crysta cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai Innova Crysta cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What are the features of the Innova Crysta cab for Pune to Mumbai trips?',
    answer: 'Our Innova Crysta cabs are spacious, luxurious, and ideal for families or corporate groups, offering comfortable seating, ample luggage space, and a smooth ride.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Innova Crysta cab trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pune–Mumbai Expressway, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book an Innova Crysta cab for corporate or airport transfers between Pune and Mumbai?',
    answer: 'Certainly. Our Innova Crysta cab services cater to corporate travel, airport pickups, and personal trips between Pune and Mumbai.',
  },
  {
    question: 'Is the Pune to Mumbai Innova Crysta cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Innova Crysta cab services between Pune and Mumbai for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Mumbai Innova Crysta cab fares?',
    answer: 'Our Innova Crysta cab fares start from ₹3,200 for a one-way Pune to Mumbai trip, depending on the pickup location, time, and additional requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Mumbai Innova Crysta cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free and secure transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Mumbai Innova Crysta cabs?',
    answer: 'All Innova Crysta cabs are sanitized before every trip, and our drivers follow strict hygiene and safety measures for a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai Innova Crysta cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai Innova Crysta cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Jadhav',
    feedback: 'I booked a Pune to Mumbai Innova Crysta cab with Sai Trupti Cabs. The car was luxurious and the driver was highly professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent service for my Pune to Mumbai trip in an Innova Crysta. Smooth, safe, and comfortable journey.',
    rating: 5,
  },
];


























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Crysta Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-innova-crysta-cab.jpg",
  "description": "Book Pune to Mumbai Innova Crysta Cab with Sai Trupti Cabs for a luxurious, safe, and comfortable ride. Perfect for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Innova Crysta rides.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "15060"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-innova-crysta-cab"
  }
};










  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Innova Crysta Cab | Luxurious & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Innova Crysta Cab with Sai Trupti Cabs for a luxurious, safe, and comfortable ride. Perfect for one-way trips, airport transfers, or outstation travel. Enjoy AC comfort, verified drivers, and 24/7 online booking for Pune to Mumbai Innova Crysta rides." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Innova Crysta Cab, Pune to Mumbai Innova Cab, Pune to Mumbai Innova Crysta Taxi, Pune to Mumbai Innova Crysta Hire, Pune to Mumbai Innova Crysta One Way Cab, Pune to Mumbai Innova Crysta Drop, Pune to Mumbai Innova Crysta Luxury Cab, Pune to Mumbai Innova Crysta Outstation Cab, Pune to Mumbai Innova Crysta Airport Taxi, Affordable Pune to Mumbai Innova Cab, Pune to Mumbai Innova Crysta Online Booking, Pune to Mumbai Innova Crysta AC Cab, Pune to Mumbai Innova Crysta Sedan Cab, Pune to Mumbai Innova Crysta Car Service, Pune to Mumbai Innova Crysta Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiinnovacrystacabs;